import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

const MINI_GAME_FIELDS = {
    seq: { type: parseInt, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    cardInfo: { type: Number, defaultValue: 0 },
    info: { type: Number, defaultValue: 0 },
    mission: { type: Number, defaultValue: 0 },
    reward: { type: Number, defaultValue: 0 },
    memo: { type: String, defaultValue: '' },
};

export class MiniGameEntity extends EntityBase {
    constructor(data = {}) {
        super(data, MINI_GAME_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
            {condition: () => this.cardInfo === 0, message: 'CardInfo 인덱스가 없습니다.'},
            {condition: () => this.info === 0, message: 'Info 인덱스가 없습니다.'},
            {condition: () => this.mission === 0, message: 'mission 인덱스가 없습니다.'},
            {condition: () => this.reward === 0, message: 'reward 인덱스가 없습니다.'},
        ];
    }

    getIdentityKey() {
        return 'index';
    }
}